import { useDispatch, useSelector } from '@redux';
import { Tag } from 'antd';
import { TRANSFER_ORDER_STATUS } from 'constants/constants';
import RestShow from 'containers/rest/Show';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';
import ShowContent from './ShowContent';
import crudActions from '@redux/crudActions';
import { useNavigate } from 'react-router-dom';
import CancelModal from '../components/Modal/CancelModal';
import ReceivedModal from '../components/Modal/ReceivedModal';

const TYPE = {
  reject: [''], //1
  confirm: [''], //2
  relocate: ['AWAITING_CONFIRMATION', 'REJECTED'], //3
  cancel: ['AWAITING_CONFIRMATION', 'CONFIRMED_PICK', 'REJECTED'], //4
  confirmReceived: ['SHIPPING'], //5
};

const Show = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = useSelector<DynamicObjectType>(
    (state) => state.transferOrders.currentData,
  );

  const EXTRA_OPTIONS = [
    {
      ...(TYPE['reject'].includes(data?.status)
        ? {
            label: 'Reject',
            key: 'reject',
          }
        : null),
    },
    {
      ...(TYPE['confirm'].includes(data?.status)
        ? {
            label: 'Confirm',
            key: 'confirm',
          }
        : null),
    },
    {
      ...(TYPE['relocate'].includes(data?.status)
        ? {
            label: 'Edit',
            key: 'relocate',
          }
        : null),
    },
    {
      ...(TYPE['cancel'].includes(data?.status)
        ? {
            label: 'Cancel',
            key: 'cancel',
          }
        : null),
    },
    {
      ...(TYPE['confirmReceived'].includes(data?.status)
        ? {
            label: 'Confirm received',
            key: 'confirmReceived',
          }
        : null),
    },
  ];

  const tempOrderStatus = TRANSFER_ORDER_STATUS[data?.status];

  const openRejectModal = () => {
    dispatch(
      crudActions.modal.toogleModal({
        ['reject']: {
          isOpen: true,
        },
      } as any),
    );
  };

  const openConfirmModal = () => {
    dispatch(
      crudActions.modal.toogleModal({
        ['confirm']: {
          isOpen: true,
        },
      } as any),
    );
  };

  const handleCancel = () => {
    dispatch(
      crudActions.modal.toogleModal({
        ['cancel']: {
          isOpen: true,
        },
      } as any),
    );
    // dispatch(
    //   cancelTransferOrders({
    //     data: {
    //       id: data?.id,
    //     },
    //     options: {
    //       isShowSuccessNoti: true,
    //     },
    //   }),
    // ).then((res) => {
    //   if (res?.payload?.success) {
    //     navigate(`/transfer-orders?status=CANCELLED`);
    //   }
    // });
  };

  const handleReceivedModal = (value) => {
    dispatch(
      crudActions.modal.toogleModal({
        ['received']: {
          isOpen: value,
        },
      } as any),
    );
  };

  const handleRelocate = () => {
    navigate(`/transfer-orders/${data?.id}/edit`);
  };

  const handleExtraOptions = (e) => {
    switch (e.key) {
      case 'reject': {
        return openRejectModal();
      }
      case 'confirm': {
        return openConfirmModal();
      }
      case 'relocate': {
        return handleRelocate();
      }
      case 'cancel': {
        return handleCancel();
      }
      case 'confirmReceived': {
        return handleReceivedModal(true);
      }
    }
  };

  const handleParamsBreadcrumb = useMemo(() => {
    if (!TRANSFER_ORDER_STATUS?.[data?.status]) {
      return {
        title: 'All',
        href: '/transfer-orders',
      };
    }
    return {
      title: t(TRANSFER_ORDER_STATUS?.[data?.status]?.text || ''),
      href: `/transfer-orders?customLayout=${data?.status}&filters=${encodeURIComponent(
        JSON.stringify(
          [
            {
              condition: 'and',
              key: 'status',
              operator: 'is',
              value: data?.status,
            },
          ],
          null,
          0,
        ),
      )}`,
    };
  }, [data?.status]);

  const breadcrumbs = [
    {
      title: 'common.page.transferOrders',
      href: '/transfer-orders',
    },
    {
      title: handleParamsBreadcrumb?.title,
      href: handleParamsBreadcrumb?.href,
    },
    ['SHIPPING'].includes(data?.status)
      ? {
          title: `Batch ID ${data?.transferOrderBatch?.id}`,
          href: `/transfer-orders/${data?.transferOrderBatch?.id}/detail`,
        }
      : {},
    {
      title: (
        <span className="font-bold text-sm text-[--primary]">
          {`#${data?.toId || data?.id || data?.transferNumber}`}
        </span>
      ),
    },
  ];

  return (
    <>
      <RestShow
        model="transferOrders"
        // customBreadcrumb={<CustomBreadCrumb data={data} />}
        breadcrumbs={breadcrumbs?.filter((item) => !!item?.title)}
        extraBreadcrumb={
          <Tag
            color={TRANSFER_ORDER_STATUS[data?.status]?.background}
            style={{ borderRadius: 5, padding: '5px 10px', border: 'none' }}
          >
            <div
              style={{
                color: TRANSFER_ORDER_STATUS[data?.status]?.color,
              }}
            >
              {t(tempOrderStatus?.text)}
            </div>
          </Tag>
        }
        extraOptions={EXTRA_OPTIONS}
        handleExtraOptions={handleExtraOptions}
        apiOptions={{
          extraParams: {
            join: ['order', 'histories', 'histories.creator'],
          },
          isRequestApi: true,
        }}
      >
        <ShowContent data={data} />
      </RestShow>
      <CancelModal
        onCancel={() =>
          dispatch(
            crudActions.modal.toogleModal({
              ['cancel']: { isOpen: false },
            } as any),
          )
        }
      />
      <ReceivedModal
        data={data}
        onCancel={() => handleReceivedModal(false)}
        callback={() => window.location.reload()}
      />
    </>
  );
};

export default Show;
